class PostsTabsClass {
  init() {
    class Tabs {
      constructor(switcherWrapper) {
        this.indicator = document.querySelector(
          ".posts__menu__switcher-indicator"
        );
        this.menuItems = document.querySelectorAll(
          ".posts__menu__switcher-button"
        );
        this.menuItemsWidth = [];
      }

      marker(target, index) {
        this.indicator.style.left = target.offsetLeft + "px";
        this.indicator.style.width = this.menuItemsWidth[index];
        this.menuItems.forEach((item) => {
          if (item != target) {
            item.classList.remove("active");
          } else {
            item.classList.add("active");
          }
        });
      }

      switch(e, index) {
        this.marker(e.target, index);
      }

      init() {
        this.menuItems.forEach((item) => {
          let itemWidth = window.getComputedStyle(item).width;
          this.menuItemsWidth.push(itemWidth);
        });

        this.indicator.style.width = this.menuItemsWidth[0];
        this.menuItems.forEach((item, i) => {
          item.addEventListener("click", (e) => {
            this.switch(e, i);
          });
        });
      }
    }

    new Tabs(".posts__menu__switcher").init();
  }
}

export const PostsTabs = new PostsTabsClass();
